import { InteractiveList } from '@nimbus-ds/patterns';
import { SelectedProductInterface } from 'domains/Catalog/Products/components/SelectProductList/types';
import VariantListItem from './VariantListItem/VariantListItem';
import './VariantList.scss';

interface VariantListProps {
  variants: SelectedProductInterface[];
  selectedVariantIds: string[];
  onAdd: (variantIds: string[]) => void;
  onRemove: (variantIds: string[]) => void;
}

function VariantList({
  variants,
  selectedVariantIds,
  onAdd,
  onRemove,
}: Readonly<VariantListProps>): JSX.Element {
  const getVariantName = (variant: SelectedProductInterface): string => {
    if (!variant.attributes || variant.attributes.length === 0) {
      return variant.name;
    }

    return variant.attributes
      .map((attr) => attr.values.join(', '))
      .filter(Boolean)
      .join(' / ');
  };

  return (
    <div className="stratus--variant-list-container">
      <InteractiveList>
        {variants.map((variant) => (
          <div
            key={variant.id}
            className="stratus--variant-list-item-container"
          >
            <VariantListItem
              variant={variant}
              selectedVariantIds={selectedVariantIds}
              name={getVariantName(variant)}
              onAdd={onAdd}
              onRemove={onRemove}
            />
          </div>
        ))}
      </InteractiveList>
    </div>
  );
}

export default VariantList;
